import API_BACK from "../lib/axiosBack";
// import API from "../lib/axios";
import { WithdrawalFilters, WithdrawalResponse } from "../types/withdrawal";

function calculatePageSize(): number {
  const rowHeight = 48;
  const offset = 300;
  const availableHeight = window.innerHeight - offset;
  return Math.max(5, Math.floor(availableHeight / rowHeight));
}

let currentSize = calculatePageSize();
const listeners = new Set<() => void>();

window.addEventListener("resize", () => {
  currentSize = calculatePageSize();
  listeners.forEach((fn) => fn());
});

export const subscribeToResizeWithdrawals = (fn: () => void) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const getWithdrawals = async (
  page = 0,
  size = currentSize,
  filters?: WithdrawalFilters
): Promise<WithdrawalResponse> => {
  const token = localStorage.getItem("accessToken");

  const params: Partial<WithdrawalFilters> & {
    page: number;
    size: number;
    sort: string;
  } = {
    page,
    size,
    sort: "withdrawalTime,DESC",
  };

  if (filters) {
    if (filters.withdrawalTimeFrom)
      params.withdrawalTimeFrom = new Date(
        filters.withdrawalTimeFrom
      ).toISOString();

    if (filters.withdrawalTimeTo)
      params.withdrawalTimeTo = new Date(
        filters.withdrawalTimeTo
      ).toISOString();
  }

  try {
    const response = await API_BACK.get<WithdrawalResponse>(
      "/withdrawals/external",
      // const response = await API.get<WithdrawalResponse>(
      //   "/back/withdrawals/external",
      {
        params,
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error: any) {
    const status = error?.response?.status;
    if (status === 400) {
      console.error("📛 Error 400: Invalid request parameters.");
    } else if (status === 401) {
      console.error("🔒 Error 401: Unauthorized.");
    } else if (status === 500) {
      console.error("💥 Error 500: Internal Server Error.");
    } else {
      console.error("❌ Unknown error:", error);
    }
    throw error;
  }
};
